// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__bLjWw","text":"SelectPayment_text__2WMP4","title":"SelectPayment_title__1Q_Ce","btn":"SelectPayment_btn__39zdC"};